import React, { Component } from "react";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import { Link } from "react-router-dom";

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      html: null,
      script: null,
    };
  }

  componentDidUpdate() {
    if (
      !document.getElementById("get") &&
      document.getElementById("paysonContainer") &&
      this.state.html
    ) {
      const container = document.getElementById("paysonContainer");
      const script = document.createElement("script");
      //script.async = true;
      script.type = "text/javascript";
      script.id = "get";
      script.src = this.state.script;
      script.async = true;
      container.appendChild(script);
    }
  }

  componentDidMount() {
    fetch(
      this.props.url +
        (this.props.isLunda
          ? "/api/lundarundan/payment/pay"
          : "/api/payment/pay"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: this.props.token,
          //id: id
        }),
      }
    )
      .then((res) => res.json())
      .then((json) => {
        this.setState({
          ...json,
        });
        if (json?.success && json?.snippet) {
          const script = json.snippet.split("src='")[1].split("'></script>")[0];
          this.setState({
            html: json.snippet,
            script: script,
          });
        }
      });
  }

  render() {
    return (
      <div id="payment" className="noheader">
        {this.state.mes && <p>message: {this.state.mes}</p>}
        {this.state.html ? (
          <div>
            <div className="paymentContainer">
              {ReactHtmlParser(this.state.html)}
            </div>
            <div className="paymentContainer button-container">
              <Link to="/betalat">
                <button>
                  <p>Fortsätt</p>
                </button>
              </Link>
            </div>
          </div>
        ) : (
          <div className="sk-circle">
            <div className="sk-circle1 sk-child"></div>
            <div className="sk-circle2 sk-child"></div>
            <div className="sk-circle3 sk-child"></div>
            <div className="sk-circle4 sk-child"></div>
            <div className="sk-circle5 sk-child"></div>
            <div className="sk-circle6 sk-child"></div>
            <div className="sk-circle7 sk-child"></div>
            <div className="sk-circle8 sk-child"></div>
            <div className="sk-circle9 sk-child"></div>
            <div className="sk-circle10 sk-child"></div>
            <div className="sk-circle11 sk-child"></div>
            <div className="sk-circle12 sk-child"></div>
          </div>
        )}
      </div>
    );
  }
}

export default Confirmation;
